"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GenericImageIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _SvgIcon = _interopRequireDefault(require("../utils/SvgIcon"));

function GenericImageIcon(_ref) {
  let {
    name,
    href
  } = _ref,
      propsWith = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["name", "href"]);
  return /*#__PURE__*/React.createElement(_SvgIcon.default, (0, _extends2.default)({
    "data-testid": `${name}Icon`
  }, propsWith), /*#__PURE__*/React.createElement("image", (0, _extends2.default)({
    href: href
  }, propsWith)));
}

process.env.NODE_ENV !== "production" ? GenericImageIcon.propTypes = Object.assign({
  name: _propTypes.string,
  href: _propTypes.string,
  viewBox: _propTypes.string
}, _propTypes2.default.layout) : void 0;
GenericImageIcon.defaultProps = {
  x: 0,
  y: 0
};